"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@material-ui/core");
var continueButtonStyles_1 = require("./continueButtonStyles");
var useJourneyStepsContext_1 = require("../../../hooks/useJourneyStepsContext");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var clsx_1 = require("clsx");
var ContinueButton = function (_a) {
    var testId = _a.testId, activateNextStep = _a.activateNextStep, _b = _a.disabled, disabled = _b === void 0 ? false : _b, handleClick = _a.handleClick, loading = _a.loading, className = _a.className;
    var _c;
    var styles = continueButtonStyles_1.default();
    var handleNext = useJourneyStepsContext_1.default().handleNext;
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    return (<core_1.Button type="button" variant="contained" color="primary" onClick={activateNextStep ? handleNext : handleClick} className={clsx_1.default(styles.continueButton, className)} classes={{ containedPrimary: styles.newContainedPrimary, contained: styles.newContained }} disabled={disabled} data-test={testId} disableTouchRipple={!!((_c = checkout4) === null || _c === void 0 ? void 0 : _c.disableTouchRipple)}>
      {loading && (<core_1.CircularProgress size={15} className={styles.loader} data-test="checkout:continue_button:select_journey:loader"/>)}
      <Translation_1.default id="trans__checkout__next_step__continue_CTA"/>
    </core_1.Button>);
};
exports.default = ContinueButton;
